var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};

// src/FlagIcon.tsx
import React, { forwardRef } from "react";
var FlagIcon = forwardRef((_a, ref) => {
  var _b = _a, { code, alt = code, size = 24, width = size, height = size } = _b, props = __objRest(_b, ["code", "alt", "size", "width", "height"]);
  return /* @__PURE__ */ React.createElement("img", __spreadProps(__spreadValues({}, props), {
    ref,
    alt,
    width,
    height,
    src: `https://cdn.jsdelivr.net/gh/umidbekk/react-flag-kit@1/assets/${code}.svg`
  }));
});
FlagIcon.displayName = "FlagIcon";
export {
  FlagIcon
};
